import { Tabs } from "antd";
import OrderReport from "./tabItems/OrderReport";

const ReportTab = () => {
    const tabs = [
        {
          key: '1',
          label: 'Orders',
          children: <OrderReport />,
        }
    ];

    const onChange = (key) => {
        // console.log(key);
    };

    return (
        <div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default ReportTab;